import React, { memo } from "react"
import { Trans } from "@lingui/macro"
import { NoItemsMessage } from "@components/Lists/NoItemsMessage"
import LazyKnowledgeInlineEditor from "../LazyKnowledgeInlineEditor"

const PeekArticle = memo(({ knowledge, hasRestrictedToKiosk, onArticleChange }) => {
  if (hasRestrictedToKiosk) {
    return (
      <NoItemsMessage>
        <Trans>
          This article is restricted to kiosk devices for your permission level.
          <br />
          Please access it on a kiosk device to view.
        </Trans>
      </NoItemsMessage>
    )
  }

  return (
    <LazyKnowledgeInlineEditor
      initialContent={knowledge.content}
      contentOnly
      from="peek"
      onArticleChange={onArticleChange}
    />
  )
})

PeekArticle.displayName = "PeekArticle"

export { PeekArticle }
